import * as actions from './actions';

export type State = {
  loading: boolean;
  data: Array<Record<string, any>>;
  error: object;
};

export default (
  state: State = {
    loading: false,
    data: [],
    error: {},
  },
  action: any = {},
): State => {
  switch (action.type) {
    case actions.FETCH_EXPENSE_EVENTS:
      return {
        ...state,
        loading: true,
      };
    case actions.FETCH_EXPENSE_EVENTS_SUCCESS:
      const expenseEventsContent =
        action.payload &&
        action.payload.map((ee: any) => {
          return {
            value: ee.elements.sourceValue.value,
            name: ee.elements.sourceDisplayName.value,
          };
        });
      
      return {
        ...state,
        data: expenseEventsContent,
      };
    case actions.FETCH_EXPENSE_EVENTS_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};
